import { render, staticRenderFns } from "./LsSectionIndex.vue?vue&type=template&id=6997bb23&scoped=true&"
import script from "./LsSectionIndex.vue?vue&type=script&lang=js&"
export * from "./LsSectionIndex.vue?vue&type=script&lang=js&"
import style0 from "./LsSectionIndex.vue?vue&type=style&index=0&id=6997bb23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997bb23",
  null
  
)

export default component.exports